import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
// Assuming Button component is available like in Hero
import { Button } from "../ui/button.jsx";
// Import the background image
import heroBg from "../../assets/hero-bg2.jpeg"; // Adjust path if necessary

const CtaBand = () => {
    return (
        // Added relative and overflow-hidden, kept padding
        <motion.section
            className="relative bg-light text-primary-foreground py-24 md:py-32 overflow-hidden"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
        >
            {/* z-0: Background Image with Overlay (Copied from Hero) */}
            <div
                className="absolute inset-0 z-0"
                style={{
                    backgroundImage: `url(${heroBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center', // Ensures center alignment
                    backgroundAttachment: 'fixed', // <-- ADD THIS LINE
                    filter: 'blur(0px)', // Adjust blur as needed
                }}
            >
                {/* Dark overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-neutral-900/30 via-neutral-900/50 to-neutral-900/70"></div>
            </div>

            {/* z-1: Floating Geometric Shapes (Copied from Hero) */}
            <div className="absolute inset-0 z-1">
                <div className="absolute top-10 left-10 w-24 h-24 bg-brand/10 rounded-full blur-3xl animate-float"></div>
                <div className="absolute bottom-10 right-10 w-32 h-32 bg-aiApplications/10 rounded-full blur-3xl animate-float" style={{ animationDelay: '2s' }}></div>
                <div className="absolute top-1/2 left-1/4 w-20 h-20 bg-brand/5 rounded-full blur-2xl animate-float" style={{ animationDelay: '4s' }}></div>
            </div>

            {/* z-10: Main Content */}
            <div className="container mx-auto px-6 text-center relative z-10">
                <h2 className="text-4xl md:text-5xl font-bold max-w-3xl mx-auto leading-tight text-white font-serif"> {/* Matched font */}
                    Build with us across Europe, the Gulf, and India.
                </h2>
                <motion.div
                    className="mt-10"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    viewport={{ once: true }}
                >
                    <Link to="/contact">
                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <Button variant="hero" size="lg">
                                Share your deck
                            </Button>
                        </motion.div>
                    </Link>
                </motion.div>
            </div>

            {/* z-5: White Gradient Fade (BOTTOM) - Kept existing */}
            {/* <div
                className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-background to-transparent z-5" // Fade To Top
            ></div> */}
        </motion.section>
    );
};

export default CtaBand;